export const assigneeGroupsTheme = {
   light: {
      common: {
         cardBgColor: 'bg-base-white',
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-700',
         defaultBorderColor: 'border-gray-300',
         secondaryDescriptionColor: 'text-gray-500',
         refreshHandlerBgColor: '!bg-base-white'
      },
      assigneeGroupSidePane: {
         headerTitleColor: 'text-gray-900',
         headerDescriptionColor: 'text-gray-600'
      }
   },
   dark: {}
}
